import { PlusIcon } from '@heroicons/react/24/outline';
import Pagination from '../components/Pagination';
import ProjectSearchBar from '../components/projects/ProjectSearchBar';
import ProjectGrid from '../components/projects/ProjectGrid';
import ProjectFormDrawer from '../components/projects/ProjectFormDrawer';
import CreateScriptSection from '../components/ScriptGeneration/CreateScriptSection';
import { useProjects } from '../hooks/useProjects';
import { useTranslation } from 'react-i18next';

export default function ProjectsPage() {
  const { t } = useTranslation(['project', 'common']);
  const {
    projects,
    loading,
    showForm,
    editingProject,
    formData,
    searchTerm,
    pagination,
    setFormData,
    setShowForm,
    handleSubmit,
    handleEdit,
    handleDelete,
    handleSearchChange,
    handleClearSearch,
    resetForm,
    handlePageChange
  } = useProjects();

  return (
    <div className="h-screen bg-bg-page">
      <div className="overflow-auto h-full overflow-x-hidden">
        <div className='mb-16 overflow-visible'>
          <CreateScriptSection showScriptTab />
        </div>
        <div className="p-6">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
            <div>
              <h1 className="text-2xl font-semibold text-gray-50">{t('project:title')}</h1>
              <p className="mt-1 text-sm text-gray-400">{t('project:subtitle')}</p>
            </div>
            <div className="flex items-center gap-3">
              <ProjectSearchBar
                searchTerm={searchTerm}
                onSearchChange={handleSearchChange}
                onClearSearch={handleClearSearch}
              />
              <button
                onClick={() => setShowForm(true)}
                className="flex items-center gap-2 px-4 py-2 bg-primary hover:bg-primary-dark text-white text-sm font-medium rounded-lg transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                <PlusIcon className="h-4 w-4" />
              </button>
            </div>
          </div>

          <ProjectGrid
            projects={projects}
            loading={loading}
            onCreateProject={() => setShowForm(true)}
            onEditProject={handleEdit}
            onDeleteProject={handleDelete}
          />

          <ProjectFormDrawer
            isOpen={showForm}
            editingProject={editingProject}
            formData={formData}
            onFormDataChange={setFormData}
            onSubmit={handleSubmit}
            onClose={() => {
              setShowForm(false);
              resetForm();
            }}
          />

          {pagination.totalPages > 1 && (
            <div className="bg-bg-surface rounded-xl border border-border-subtle shadow-sm p-4 mt-6">
              <Pagination
                page={pagination.page}
                limit={pagination.limit}
                total={pagination.total}
                totalPages={pagination.totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
